import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const MagnetIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M13.2098 3.60072L15 1L11.2458 2.2912C10.935 2.39784 10.9371 2.73456 11.2495 2.87508L12.4119 3.3977L9.99902 6.00023L14.3772 4.70929C14.6889 4.60311 14.6874 4.2658 14.3745 4.12508L13.2098 3.60072Z"
		></path>
		<path
			fill="currentColor"
			d="M5.04749 4.4638L7.21039 6.62671L8.5622 5.27489C8.71152 5.12557 8.71152 4.88348 8.5622 4.73417L6.94003 3.11199C6.79071 2.96267 6.54862 2.96267 6.3993 3.11199L5.04749 4.4638Z"
		></path>
		<path
			fill="currentColor"
			d="M4.2364 5.27489L2.34386 7.16743C0.552048 8.95924 0.552048 11.8643 2.34386 13.6561C4.13566 15.448 7.04076 15.448 8.83257 13.6561L10.7251 11.7636L8.5622 9.6007L6.66966 11.4932C6.07239 12.0905 5.10403 12.0905 4.50676 11.4932C3.90949 10.896 3.90949 9.92761 4.50676 9.33034L6.3993 7.4378L4.2364 5.27489Z"
		></path>
		<path
			fill="currentColor"
			d="M11.5362 10.9525L9.37329 8.78961L10.7251 7.4378C10.8744 7.28848 11.1165 7.28848 11.2658 7.4378L12.888 9.05997C13.0373 9.20929 13.0373 9.45138 12.888 9.6007L11.5362 10.9525Z"
		></path>
	</svg>
))
